import {DomElement,svgIcons,convert2d3d} from '../../types/datatypes'

const iconlist=Object.keys(svgIcons)


class IconElement extends DomElement{
  createDom(){
    var container=this.createContainer()
    //const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg")
    var html=`<div class="title padding-sm" style="border-color:`+this.params.color+`">`+this.params.name+`</div>`
    if(this.params.value){
      html+=`<div class="value">`+svgIcons[this.params.value]+`</div>`
    }
    container.innerHTML=html
   var icon= container.querySelector('.icon')
   icon.setAttribute('width',36)
   icon.setAttribute('height',36)
   icon.setAttribute('fill',this.params.color)
    return container
  }
  update(mesh,data){
      super.update(mesh,data)
      mesh.element.querySelector('.title').innerHTML=mesh.userData.params.name
      if(data.hasOwnProperty('alarm')){
          var color=getAlarmColor(mesh.userData.params.alarm)
          mesh.element.querySelector('.title').style.borderColor=color
          mesh.element.querySelector('.icon').setAttribute('fill',color)
      }
      if(data.hasOwnProperty('x')&&data.hasOwnProperty('z')){
          mesh.position.setX(data.x)
          mesh.position.setZ(data.z)
      }
      if(mesh.userData.params.hasOwnProperty('state')&&mesh.userData.params.state==true){
        mesh.element.style.filter=''
      }else{
        mesh.element.style.filter='grayscale(100%)'
      }
    }
}
const dom=new IconElement('icon','图标')
dom.params={
  name:'',
  value:'location',
  color:'#ffffff',
  use3d:false,
  size:32,
  state:true,
  setting:['namevalue','xyz']
}
dom.format={
  name:{name:'名称',change(mesh,v){
    mesh.element.querySelector('.title').innerHTML=v
  }},
  color:{name:'颜色',domtype:'color',change(mesh,v){
    mesh.element.querySelector('.title').style.borderColor=v
    mesh.element.querySelector('.icon').setAttribute('fill',v)
  }},
  size:{name:'大小',domtype:'number',change(mesh,v){
    var t=mesh.element.querySelector('.icon')
    t.setAttribute('width',v)
    t.setAttribute('height',v)
  }},

  value:{name:'图标',domtype:'select',data:iconlist,change(mesh,v){
    mesh.element.querySelector('.value').innerHTML=svgIcons[v]
    var t=mesh.element.querySelector('.icon')
    t.setAttribute('fill',mesh.userData.params.color)
     t.setAttribute('width',mesh.userData.params.size)
    t.setAttribute('height',mesh.userData.params.size)
  }},
  state:{name:'在线',domtype:'switch',data:Object.keys(svgIcons),change(mesh,v){
          if(v){
            mesh.element.style.filter=''
          }else{
            mesh.element.style.filter='grayscale(100%)'
          }
        }},
  use3d:{name:'3d对象',domtype:'switch',change(mesh,v){
               convert2d3d(mesh,v)
  }}
}
export default dom
